import React from 'react';

export default function FlexCol({ className, children }) {
  return <div className={`flex flex-col ${className}`}>{children}</div>;
}
